// Vendor bases allowed to add multiple credentialed instances in the UI.
// Add a base here (e.g. "chimp", "chirp", "cam") to roll out the "Add Account" button for it.
export const MULTI_INSTANCE_VENDORS = ["klav", "chimp", "chirp", "cam"];

export const isMultiInstanceEnabled = (base) => MULTI_INSTANCE_VENDORS.includes(base);

export default MULTI_INSTANCE_VENDORS;
